export default class Hero {
  constructor(object) {
    try {
      this.map(object)
    } catch(e) {
      console.warn('Invalid Type: ModelHero')
    }
  }

  map(object) {
    this.id = object.hero_id
    this.seriesId = object.series_id
    this.seriesName = object.series_name
    this.name = object.name
    this.kana = object.kana
    this.isSameName = object.is_same_name
    this.isSamePerson = object.is_same_person
    this.baseHeroId = object.base_hero_id
    this.isNotUse = object.is_not_use
  }

}
